import { Col, Progress, Row } from "antd";
import React from "react";
import { getSummaryDisplayType } from "../../../selectors";
import { connect } from "react-redux";
import { switchSummaryDisplayType } from "../../../actions/stats";
import DoughnutProvider from "../Global/DoughnutProvider";
import { toUnit, toWeightStr } from "../../../summary/format";

const DimensionValue = props => {
  let value = <span>{props.valueStr || ""}</span>;
  if ((props.format === "%" || props.format === "/") && props.v !== null && props.n !== null) {
    value = `${value} ${props.v}/${props.n}`;
    value = (
      <React.Fragment>
        <span style={{ fontWeight: "bold" }}>{props.valueStr || ""}</span>{" "}
        <span style={{ fontSize: 11 }}>{`${toUnit(props.v, props.unit, props.n)}/${toUnit(props.n, props.unit)}`}</span>
      </React.Fragment>
    );
  } else if (props.format === "weight") {
    value = (
      <React.Fragment>
        <span style={{ fontWeight: "bold" }}>{props.valueStr || ""}</span>{" "}
        <span style={{ fontSize: 11 }}>{toWeightStr(props.v, props.n)}</span>
      </React.Fragment>
    );
  } else if (props.unit) {
    value = <span>{toUnit(props.v, props.unit) || ""}</span>;
  }

  if (props.value === null)
    return (
      <Row>
        <Col span={18} style={{ textAlign: "left" }}>
          {/*Aucune donnée*/}
        </Col>
      </Row>
    );
  return (
    <Row>
      <Col span={props.colProgressBar}>
        {props.progressBarDelay ? (
          <DoughnutProvider values={[0, props.value || 0]} indexGraph={props.indexGraph}>
            {percentage => <Progress strokeColor={props.progressColor} percent={percentage} showInfo={false} />}
          </DoughnutProvider>
        ) : (
          <Progress strokeColor={props.progressColor} percent={props.value} showInfo={false} />
        )}
      </Col>
      <Col span={props.colRatio} offset={1}>
        <div
          style={{ cursor: "pointer", fontSize: 11 }}
          onClick={() => {
            props.switchSummaryDisplayType();
          }}
        >
          {value}
        </div>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    displayType: getSummaryDisplayType(state)
  };
};

export default connect(mapStateToProps, { switchSummaryDisplayType })(DimensionValue);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Dimension/DimensionValue.js